module.exports = __webpack_public_path__ + "img/photo4.f7325e9a.png";